import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";
import Flickity from 'flickity';
const serialize = require('form-serialize');

const selectors = {
    shippingPopUp: 'shippingModal',
    shippingPopUpForm: 'popupShippingForm',
    shippingPopUpCheckbox: '#popupShippingForm input[type=checkbox]',
    collectionModal: '[data-section-type="shipping-modal-section"]',
    productList: '.product-list--shipping-modal',
    productItem: '.shipping-popup--item'
  }; 
function colorSwatch(){
    const shippingPopUp = document.getElementById(selectors.shippingPopUpForm);
    if (!!shippingPopUp) {
        shippingPopUp.querySelectorAll('.product-item__swatch-list .color-swatch__radio').forEach(function (swatch) {
            swatch.addEventListener('change',e => {
                var shippingProductItem = e.target.closest('.shipping-popup--item')
                var variantShippingUrl = e.target.getAttribute('data-variant-url');
    
                shippingProductItem.querySelector('.product-item__image-wrapper').setAttribute('href', variantShippingUrl);
    
    
                var originalImage = shippingProductItem.querySelector('.product-item__primary-image');
    
                if (e.target.hasAttribute('data-image-url') && e.target.getAttribute('data-media-id') !== originalImage.getAttribute('data-media-id')) {
                  var newImage = document.createElement('img');
                  newImage.className = 'product-item__primary-image lazyload image--fade-in';
                  newImage.setAttribute('data-media-id', e.target.getAttribute('data-media-id'));
                  newImage.setAttribute('data-src', e.target.getAttribute('data-image-url'));
                  newImage.setAttribute('data-widths', e.target.getAttribute('data-image-widths'));
                  newImage.setAttribute('data-sizes', 'auto'); // Replace the original node
                  originalImage.parentNode.style.paddingBottom = "".concat(100.0 / newImage.getAttribute('data-image-aspect-ratio'), "%");
                  originalImage.parentNode.replaceChild(newImage, originalImage);
                
                }

                var selectedVariantId = e.target.getAttribute('data-variant-id')
                var formShipping = e.target.closest('.shipping-popup--item')
                var productId = e.target.getAttribute('data-original-product')
                var formInput = formShipping.querySelector(`#product-input-${productId}`)
                 if(!!formInput) {
                    formInput.value = selectedVariantId
                    document.dispatchEvent(new CustomEvent('value:changed'));
                 }
            })
        })
    }
   
}

function initializeForm(){
    const shippingModalForm = document.getElementById(selectors.shippingPopUpForm);
    const inputChecks = document.querySelectorAll(selectors.shippingPopUpCheckbox);
    document.addEventListener('qty:change', e =>{
        const parenElement = e.target.activeElement.closest('.shipping-popup--item')
        if (!! parenElement) {
            const inputElement = parenElement.querySelector('input[type=checkbox]')
            if (Number(e.target.activeElement.value) === 0 ) {
                inputElement.checked = false
                parenElement.classList.remove('shipping-product--selected')
            }else {
                inputElement.checked = true
                parenElement.classList.add('shipping-product--selected')
            }
        }
        calculateShipping()

    })

    if (!!inputChecks) {
        inputChecks.forEach(function(check){
            check.addEventListener('click', function(e){
                if (e.target.checked) {
                    e.target.parentNode.classList.add('shipping-product--selected')
                }else {
                    e.target.parentNode.classList.remove('shipping-product--selected')
                }
                calculateShipping()
            })
        })
    }

  
    let allProductsId = []
    document.querySelectorAll(selectors.shippingPopUpCheckbox).forEach(e =>{
        allProductsId.push(e.value)
    })

    document.addEventListener('value:changed', function(){
        allProductsId = []
        document.querySelectorAll(selectors.shippingPopUpCheckbox).forEach(e =>{
            allProductsId.push(e.value)
        })
    })
    // Handle the submit function
    if (!!shippingModalForm) {
        shippingModalForm.addEventListener("submit", function(e){
            e.preventDefault();
            const serializedFormData = serialize(this, { hash: true })
            let productLists = []
            if (!!allProductsId) {
                allProductsId.forEach((id, indx)=>{
                    if (!!serializedFormData.id) {
                        if (serializedFormData.id.includes(id)) {
                            productLists.push({
                                id: id,
                                quantity: serializedFormData.quantity[indx]
                            })
                        }
                    }
                })
            }
            handleFormSubmit(productLists)
        })
    }
   
}
  
function handleFormSubmit(formData) {
    let items = []
    formData.forEach((data, index) => {
        items[index] = {
        id: data.id,
        quantity: data.quantity
        }
    });
    addProductsToCart(items)
}

function addProductsToCart(items) {
    let formData = {
        items: items
    };
    // Add items via helpers file
    Helpers.addCartItems(formData).then((response) => {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('cart:rerendered'));
        if (response.status === 200) {
            window.location.reload();
        }
    });
}

// Sort products by price low/high or high/tow depending on shipping costs
function sortNodesByOrder(products) {
    if (!!!(products) || products.length < 1) {
        return;
    }
    let sortedArray = [];
    products.forEach((el) => {
        sortedArray.push(el);
        const order = el.order;
        if (!!order) {
            if (Number(order) < 2000) {
                sortedArray.sort(function(a, b) {
                    return a.productPrice - b.productPrice
                }) 
            }else {
                sortedArray.sort(function(a, b) {
                    return  b.productPrice - a.productPrice
                }) 
            } 
        }
    });

    return sortedArray;
}

// Get the products that should be sorted and create array of them
function getProductsWithOrder() {
    const modalProducts = document.querySelectorAll(`${selectors.collectionModal} ${selectors.productItem}`);
    if (!!!(modalProducts) || modalProducts.length < 1) {
        return;
    }
    if (!!!modalProducts[0].dataset.order) {
        return;
    }
    if (!!!modalProducts[0].dataset.price) {
        return;
    }

    let formattedList = [];
    modalProducts.forEach(p => {
        formattedList.push({
            order: p.dataset.order,
            productNode: p,
            productPrice: p.dataset.price
        });
    });
    return formattedList;
}

// Replace the wrapper with unsorted products with the new one
function replaceProductNodes(oldProductsList, sortedProductsList) {
    if (!!!(sortedProductsList) || sortedProductsList.length < 1) {
        return;
    }
    if (typeof oldProductsList !== 'string' || oldProductsList.length < 1) {
        return;
    }

    const oldProductWrapper = document.querySelector(oldProductsList);
    if (!!!(oldProductWrapper)) {
        return;
    }

    const wrapperEl = document.createElement('div')
    wrapperEl.classList = 'product-list product-list--vertical product-list--scrollable product-list--shipping-modal' 

    sortedProductsList.forEach((sortedProduct) =>{
        wrapperEl.appendChild(sortedProduct.productNode)
        oldProductWrapper.replaceWith(wrapperEl);
    });
    document.dispatchEvent(new CustomEvent('modal:opened'))
}

 function calculateShipping(){
    const productItems = document.querySelectorAll(`${selectors.collectionModal} ${selectors.productItem}`);
    if (!!!(productItems)) {
        return;
    }
    let total = 0
    let totalPrice = 0
    let missingShippingTemp = 0

    productItems.forEach(item =>{
        const productWrapper = item
        const shippingSpanPrice = document.querySelector('.free-shipping--missing-amount')
        const shippingSpanFree = document.querySelector('.free-shipping-text--free')
        const shippingSpan = document.querySelector('.free-shipping-text__missing-amount')
        const checkboxInput = productWrapper.querySelector('input[type=checkbox]')
        const missingShipping = Number(item.getAttribute('data-missing-shipping'))
        missingShippingTemp = Number(item.getAttribute('data-missing-shipping'))
        if (checkboxInput.checked) {
            const quantitySelector = productWrapper.querySelector('.quantity-selector')
            let productPrice = Number(quantitySelector.getAttribute('data-price'))
            let productQuantity = Number(quantitySelector.value)
            totalPrice = productPrice * productQuantity
            total = total + totalPrice
        }
        missingShippingTemp = missingShippingTemp - total
        if(missingShippingTemp <= 0){
            shippingSpan.classList.add('hidden')
            shippingSpanFree.classList.remove('hidden')
        }else {
            shippingSpan.classList.remove('hidden')
            shippingSpanFree.classList.add('hidden')
            shippingSpanPrice.innerHTML = ( missingShippingTemp / 100).toFixed(2).replace(/\./, ',')+ '€'
        }
    })

}
document.addEventListener('DOMContentLoaded', () => {
    colorSwatch()
    const sortedProducts = getProductsWithOrder();
    if(!!sortedProducts) {
        const sortedNodes = sortNodesByOrder(sortedProducts);
        replaceProductNodes(`${selectors.collectionModal} ${selectors.productList}`, sortedNodes);
    }
    document.addEventListener("modal:opened", function () {
        var fkty = new Flickity(document.querySelector('.product-list--shipping-modal'), {
            watchCSS: true,
            pageDots: false,
            prevNextButtons: true,
            contain: true,
            resize: false,
            groupCells: true,
            freeScroll: true,
            wrapAround: false,
            cellAlign: 'left',
            draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
        })
        initializeForm()
    })
});
document.addEventListener('cart:rerendered', function(){
    colorSwatch()
    const rerenderedNodes = getProductsWithOrder();
    if(!!rerenderedNodes) {
        const sortedNodesRerendered = sortNodesByOrder(rerenderedNodes);
        replaceProductNodes(`${selectors.collectionModal} ${selectors.productList}`, sortedNodesRerendered);
    }
});
